import { Frame } from "@craftjs/core";
import { Box } from "@mui/material";


const Canvas = ({ json }: { json: string }) => {

    return (
        <Box id="main-container" sx={{ height: '100%'}}>
            <Frame data={json} />
        </Box>
    )
}

export default Canvas;
